import React from "react";
import { X } from "lucide-react";
import { toast } from "react-toastify";

const ProductPdfSection = React.memo(({ pdfs, setPdfs }) => {
  return (
    <div className="space-y-5">
      <div className="flex justify-between items-center">
        <h4 className="text-white font-bold text-sm uppercase">Product PDFs</h4>

        <label
          className={`
            px-4 py-2
            rounded-xl
            border
            text-xs
            cursor-pointer
            ${
              pdfs.new.length >= 20
                ? "opacity-40 cursor-not-allowed border-white/10"
                : "bg-blue-500/10 border-blue-500/30 text-blue-400"
            }
          `}
        >
          + Upload PDF
          <input
            hidden
            type="file"
            multiple
            accept="application/pdf"
            disabled={pdfs.new.length >= 20}
            onChange={(e) => {
              const files = Array.from(e.target.files);

              const remaining = 20 - pdfs.new.length;

              const allowedFiles = files
                .filter((file) => {
                  if (file.size > 20 * 1024 * 1024) {
                    toast.error(`${file.name} is bigger than 20MB`);
                    return false;
                  }

                  return true;
                })
                .slice(0, remaining);

              const newPdfs = allowedFiles.map((file) => ({
                file,
                name: file.name,
              }));

              setPdfs((prev) => ({
                ...prev,
                new: [...prev.new, ...newPdfs],
              }));

              e.target.value = "";
            }}
          />
        </label>
      </div>

      <div className="space-y-3">
        {pdfs.existing.map((pdf, index) => (
          <div
            key={index}
            className="flex items-center gap-3 bg-white/5 border border-white/10 p-3 rounded-xl"
          >
            <div className="flex-1">
              <input
                value={pdf.name}
                onChange={(e) => {
                  const copy = [...pdfs.existing];

                  copy[index] = {
                    ...copy[index],
                    name: e.target.value,
                  };

                  setPdfs((prev) => ({
                    ...prev,
                    existing: copy,
                  }));
                }}
                className="w-full bg-black/40 border border-white/10 rounded-lg px-3 py-2 text-sm text-white"
              />
            </div>

            <button
              type="button"
              onClick={() => {
                setPdfs((prev) => ({
                  ...prev,
                  removed: [
                    ...prev.removed,
                    {
                      id: pdf._id,
                      url: pdf.url,
                    },
                  ],
                  existing: prev.existing.filter((_, i) => i !== index),
                }));
              }}
              className="bg-red-500 p-2 rounded-lg"
            >
              <X size={14} />
            </button>
          </div>
        ))}

        {pdfs.new.map((pdf, index) => (
          <div
            key={index}
            className="flex items-center gap-3 bg-white/5 border border-blue-500/30 p-3 rounded-xl"
          >
            <div className="flex-1">
              <input
                value={pdf.name}
                onChange={(e) => {
                  const copy = [...pdfs.new];

                  copy[index] = {
                    ...copy[index],
                    name: e.target.value,
                  };

                  setPdfs((prev) => ({
                    ...prev,
                    new: copy,
                  }));
                }}
                className="w-full bg-black/40 border border-white/10 rounded-lg px-3 py-2 text-sm text-white"
              />

              <p className="text-xs text-slate-500 mt-1">{pdf.file.name}</p>
            </div>

            <button
              type="button"
              onClick={() => {
                setPdfs((prev) => ({
                  ...prev,
                  new: prev.new.filter((_, i) => i !== index),
                }));
              }}
              className="bg-red-500 p-2 rounded-lg"
            >
              <X size={14} />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
});

export default ProductPdfSection;
